<template>
    <div class="menu-box">
        <div class="menu">
            <div class="menu-item" v-for="item in menus" v-bind:key="item.menuId" @mouseenter="onMouseOver($event)" @mouseleave="onMouseLeave($event)">
                <a :href="item.menuUrl" v-if="item.subMenus.length == 0">{{item.menuName}}</a>
                <a href="javascript:void(0);" v-else >{{item.menuName}}</a>
                <div class="sub-menu" v-if="item.subMenus.length > 0" >
                    <div class="menu-item" v-for="subItem in item.subMenus" v-bind:key="subItem.menuId">
                        <a :href="subItem.menuUrl">{{subItem.menuName}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'menu',
    props:{
        menus:{
            type:Array,
            default:[]
        }
    },
    methods: {
        onMouseOver(event){
            let ele = event.target.lastElementChild;
            if(ele && ele.className == "sub-menu"){
                ele.style.display = "inherit";
            }
            console.dir(event);
        },
        onMouseLeave(event){
            let ele = event.target.lastElementChild;
            if(ele && ele.className == "sub-menu"){
                 ele.style.display = "none";
            }
            console.dir(event);
        }
    }
}
</script>
<style scoped>
.menu-box{
    max-width: 1920px;
    min-width: 1200px;
    margin: 0 auto;
    background-color: #C92A3A;
    color: white;
    font-size: 18px;
    height: 36px;
    line-height: 36px;
    border-bottom: 2px solid #E95A6F;
    text-align: center;
    z-index: 200;
}
.menu{
    display: inline-block;
}
.menu-item{
    display: inline-block;
    padding-left: 72px;
    padding-right: 72px;
    cursor: pointer;
    background-color: #C92A3A;
    position: relative;
}
.menu-item:hover{
    background-color: #E95A6F;
}
.sub-menu{
    position: absolute;
    width: 216px;
    left: 0;
    display: none;
    z-index: 100;
    top: 37px;
}
a{
    color: white;
}
a:visited{
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue